import React, { useState } from "react";
import { LogIn, ShieldCheck } from "lucide-react";

const AdminLoginPage = () => {
  const [error, setError] = useState("");

  const handleLogin = () => {
    setError("");
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS,
    // THIS BREAKS THE AUTH. The redirect must be derived from window.location.
    const redirectUrl = window.location.origin + "/admin";
    window.location.href =
      "https://auth.emergentagent.com/?redirect=" + encodeURIComponent(redirectUrl);
  };

  // Surface the rare "access denied" message coming from a server redirect.
  React.useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    if (params.get("err") === "forbidden") {
      setError("Tu cuenta no está autorizada para entrar al panel administrativo.");
    }
  }, []);

  return (
    <div style={styles.page} data-testid="admin-login-page">
      <div style={styles.card}>
        <div style={styles.iconBadge}>
          <ShieldCheck size={28} strokeWidth={1.8} />
        </div>
        <h1 style={styles.title}>Panel administrativo</h1>
        <p style={styles.subtitle}>
          Acceso restringido al equipo de UnDosTres.<br />
          Inicia sesión con tu cuenta de Google `@undostres.com.mx`.
        </p>

        {error && (
          <div style={styles.errorBox} data-testid="admin-login-error">
            {error}
          </div>
        )}

        <button
          type="button"
          onClick={handleLogin}
          style={styles.googleButton}
          data-testid="admin-login-google-button"
        >
          <LogIn size={18} strokeWidth={2} />
          <span>Continuar con Google</span>
        </button>

        <div style={styles.footnote}>
          Solo cuentas en el allowlist autorizado tienen acceso. Para sumar
          a alguien al equipo, contacta a un administrador.
        </div>
      </div>
    </div>
  );
};

const styles = {
  page: {
    minHeight: "100vh",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    padding: "80px 20px",
    background:
      "radial-gradient(1200px 600px at -10% -20%, rgba(102,126,234,0.15), transparent 60%)," +
      "radial-gradient(900px 500px at 110% 110%, rgba(245,87,108,0.10), transparent 65%)," +
      "#fafafa"
  },
  card: {
    width: "100%",
    maxWidth: "440px",
    background: "#ffffff",
    borderRadius: "20px",
    padding: "48px 36px",
    border: "1px solid rgba(0,0,0,0.06)",
    boxShadow: "0 20px 60px rgba(15, 23, 42, 0.08)"
  },
  iconBadge: {
    width: "56px",
    height: "56px",
    borderRadius: "16px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
    color: "#ffffff",
    marginBottom: "20px",
    boxShadow: "0 10px 25px rgba(102,126,234,0.35)"
  },
  title: {
    fontSize: "28px",
    fontWeight: 800,
    letterSpacing: "-0.02em",
    color: "#0f172a",
    marginBottom: "10px"
  },
  subtitle: {
    fontSize: "15px",
    lineHeight: 1.55,
    color: "#475569",
    marginBottom: "28px"
  },
  errorBox: {
    background: "rgba(245,87,108,0.08)",
    border: "1px solid rgba(245,87,108,0.30)",
    color: "#b1304a",
    padding: "12px 14px",
    borderRadius: "10px",
    fontSize: "13.5px",
    marginBottom: "18px"
  },
  googleButton: {
    width: "100%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    gap: "10px",
    padding: "14px 18px",
    background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
    color: "#ffffff",
    border: "none",
    borderRadius: "12px",
    fontSize: "15px",
    fontWeight: 700,
    letterSpacing: "0.01em",
    cursor: "pointer",
    boxShadow: "0 12px 28px rgba(102,126,234,0.35)"
  },
  footnote: {
    marginTop: "22px",
    fontSize: "12.5px",
    color: "#64748b",
    lineHeight: 1.5
  }
};

export default AdminLoginPage;
